// @ts-nocheck
/* eslint-disable */
export const flFileUnknownIcon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 1H8C5.79086 1 4 2.79086 4 5V35C4 37.2091 5.79086 39 8 39H32C34.2091 39 36 37.2091 36 35V11L26 1Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M26 1V11H36" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'file-unknown' as const
};